export type AvailableRequestForm =
  | 'hotel'
  | 'foreign_flight'
  | 'domestic_flight'
  | 'shinkansen'
  | 'rentalcar'
  | 'other';

export const allAvailableRequestForms: AvailableRequestForm[] = [
  'hotel',
  'foreign_flight',
  'domestic_flight',
  'shinkansen',
  'rentalcar',
  'other'
];
